"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var u=`	
\v\f\r                　\u2028\u2029\uFEFF`;exports.whitespaces=u;
